import { useGetters } from '@/hooks/vue-utils/useVuex'

type LocaleText = Record<string, string>

const fallbackLocale = 'en-US'

export const useContentLocale = (fallback = '') => {
  const { contentLocale } = useGetters('common', ['contentLocale'])

  const pickTextFromLocale = (localeText?: LocaleText) => {
    if (!localeText) return fallback
    const locale = contentLocale.value || fallbackLocale

    const text = localeText[locale]

    return text || fallback
  }

  return { contentLocale, pickTextFromLocale }
}
